var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { List, Pagination } from "../..";
import { V2TableRow } from "./TableRow";
import { V2TableHeader } from "./TableHeader";
import { classNames } from "../../utils/classNames";
import { createUseStyles } from "react-jss";
import { TABLE_LIMIT } from "../../layouts/ArticleTable/ArticleTable";
import { V2TableForm } from "./TableForm";
import { TableLoading } from "./TableSkeleton";
import { Scrollable } from "../../Scrollable";
import { useTableContext } from "../../hooks/useTableContext";
import { TableProvider } from "./TableProvider";
import { TableEmpty } from "./TableEmpty";
export function V2Table(props) {
    if (props.form) {
        return (React.createElement(TableProvider, __assign({}, props),
            React.createElement(V2TableForm, __assign({}, props))));
    }
    return (React.createElement(TableProvider, __assign({}, props),
        React.createElement(V2TableWrapper, __assign({}, props),
            React.createElement(V2TableHeader, __assign({}, props)),
            React.createElement(V2TableBody, __assign({}, props)))));
}
export function V2TableWrapper(props) {
    var _a;
    var children = props.children, pagination = props.pagination, childTable = props.childTable;
    var tableTheme = useTableContext().tableTheme;
    var classes = useTableClasses(tableTheme, childTable);
    return (React.createElement("div", { style: { position: "relative", color: "" }, className: "".concat(!childTable ? "table-parent" : "") },
        !childTable ? (React.createElement(Scrollable, { axis: "x", className: classNames(classes.tableScrollbar) },
            React.createElement(V2TableListComponent, __assign({}, props), children))) : (React.createElement(V2TableListComponent, __assign({}, props), children)),
        pagination &&
            pagination.totalRecords &&
            pagination.totalRecords > (pagination.limit || TABLE_LIMIT) ? (React.createElement(Pagination, { offset: pagination.offset, totalRecords: pagination.totalRecords, limit: pagination.limit || TABLE_LIMIT, setOffset: pagination === null || pagination === void 0 ? void 0 : pagination.setOffset, maxPagesDisplayed: 7, disabled: ((_a = props.form) === null || _a === void 0 ? void 0 : _a.viewState) === "edit" })) : null));
}
export function V2TableListComponent(props) {
    var _a, _b, _c;
    var childTable = props.childTable;
    var _d = useTableContext(), tableWidth = _d.tableWidth, hasAction = _d.hasAction, tableTheme = _d.tableTheme;
    var drawer = props.drawer, headings = props.headings, children = props.children;
    var numberOfColumns = headings.length;
    var classes = useTableClasses(tableTheme, props === null || props === void 0 ? void 0 : props.childTable);
    return (React.createElement(List, { className: classNames(classes.table), hover: hasAction, displayStyle: "unset", role: "grid", ariaColCount: drawer || hasAction ? numberOfColumns + 1 : numberOfColumns, ariaRowCount: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) || ((_b = props.form) === null || _b === void 0 ? void 0 : _b.values[(_c = props === null || props === void 0 ? void 0 : props.form) === null || _c === void 0 ? void 0 : _c.name].length), dataId: props === null || props === void 0 ? void 0 : props.dataId, dataTestId: props === null || props === void 0 ? void 0 : props.dataTestId, id: props === null || props === void 0 ? void 0 : props.id, style: !childTable
            ? { width: tableWidth, position: "unset" }
            : { position: "unset" }, dataHook: childTable ? "child-table" : undefined }, children));
}
export function V2TableBody(props) {
    var _a, _b;
    if (props === null || props === void 0 ? void 0 : props.loading) {
        return React.createElement(TableLoading, __assign({}, props));
    }
    var rowIndex = 0;
    return (React.createElement(Fragment, null, (props === null || props === void 0 ? void 0 : props.data) && ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(Fragment, null, (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 : _b.map(function (item, i) {
        rowIndex++;
        return (React.createElement(V2TableRow, __assign({}, props, { item: item, key: i, rowIndex: rowIndex })));
    }))) : (React.createElement(TableEmpty, __assign({}, props)))));
}
function useTableClasses(tableStyles, childTable) {
    var _a, _b, _c, _d, _e, _f;
    var body = tableStyles.body, header = tableStyles.header;
    var useStyles = createUseStyles({
        table: {
            "& .list_row--header-start": ((_a = header === null || header === void 0 ? void 0 : header.borderLeft) === null || _a === void 0 ? void 0 : _a.width) !== 0
                ? {
                    backgroundColor: "".concat((_b = header === null || header === void 0 ? void 0 : header.borderLeft) === null || _b === void 0 ? void 0 : _b.color),
                }
                : {},
            "& .list_row--header-end": ((_c = header === null || header === void 0 ? void 0 : header.borderRight) === null || _c === void 0 ? void 0 : _c.width) !== 0
                ? {
                    backgroundColor: "".concat((_d = header === null || header === void 0 ? void 0 : header.borderRight) === null || _d === void 0 ? void 0 : _d.color),
                }
                : {},
            display: "table",
            width: "100%",
            "& .list_row--header-start, .list_row--header-end": {
                position: "absolute",
                top: 0,
                width: !childTable ? 1 : 0,
            },
            borderBottom: !childTable ? body === null || body === void 0 ? void 0 : body.borderBottom : {},
        },
        tableScrollbar: {
            borderRight: body === null || body === void 0 ? void 0 : body.borderRight,
            borderLeft: body === null || body === void 0 ? void 0 : body.borderLeft,
            borderBottomLeftRadius: (_e = body === null || body === void 0 ? void 0 : body.borderRadiusBottomLeft) !== null && _e !== void 0 ? _e : 0,
            borderBottomRightRadius: (_f = body === null || body === void 0 ? void 0 : body.borderRadiusBottomRight) !== null && _f !== void 0 ? _f : 0,
        },
    });
    return useStyles();
}
